import * as React from "react";

import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";
import twMerge from "@replo/design-system/utils/twMerge";
import DeprecatedButton from "@v1/components/designSystem/button/Button";

type ButtonGroupOption = {
  label: React.ReactNode;
  tooltipText?: string;
  onClick(): void;
  isDisabled?: boolean;
};

type ButtonGroupComponentProps = {
  options: ButtonGroupOption[];
  className?: string;
  style?: React.CSSProperties;
};

const ButtonItem = ({
  option,
  isDisabled = false,
}: {
  option: ButtonGroupOption;
  isDisabled?: boolean;
}) => {
  function _renderButton() {
    return (
      <DeprecatedButton
        disabled={isDisabled || option.isDisabled}
        variant="secondary"
        size="sm"
        UNSAFE_className="rounded-none shadow-none p-0 p-1 border-0 flex-1"
        hasMinDimensions={false}
        onClick={(e) => {
          // TODO (Noah, 2022-11-19): preventDefault is necessary to keep focus from
          // moving to this button since that would close any active popover. There's
          // probably some better way to get around this, I don't think we're configuring
          // popover focus correctly
          e.preventDefault();
          option.onClick();
        }}
      >
        {option.label}
      </DeprecatedButton>
    );
  }

  return option.tooltipText ? (
    <Tooltip content={option.tooltipText} triggerAsChild>
      {_renderButton()}
    </Tooltip>
  ) : (
    _renderButton()
  );
};

const ButtonGroupComponent = ({
  options,
  className,
}: ButtonGroupComponentProps) => {
  return (
    <div
      className={twMerge(
        "border-0.5 border-component-border shadow-2xs flex h-6 min-w-[50px] flex-row items-center overflow-hidden rounded-md p-0",
        className,
      )}
    >
      {options.map((option, index) => {
        return (
          <React.Fragment key={index.toString()}>
            {index !== 0 && (
              <div className="border-border h-4 self-center border-r" />
            )}
            <ButtonItem option={option} />
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ButtonGroupComponent;
